import { render, staticRenderFns } from "./rawMaterialGroupTable.vue?vue&type=template&id=b1be7282"
import script from "./rawMaterialGroupTable.vue?vue&type=script&lang=ts"
export * from "./rawMaterialGroupTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports